import { GoogleOAuthProvider } from '@react-oauth/google';
import { executionAsyncId } from 'async_hooks';

// Pre-warm the TTS endpoint so the audio is cached locally for instant playback
const WarmEnglishWord = async (inputText: string): Promise<void> => {
  try {
    await fetch(
      `/api/v1/tts?content=${encodeURIComponent(inputText)}&voice=${encodeURIComponent('af_bella')}`,
      { method: 'GET', cache: 'force-cache' }, // keep it in browser cache
    );
  } catch {
    // silent fail: warming is best-effort
  }
};

// SpeakEnglish calls an API to fetch the audio. If successful, it plays the file directly; otherwise, it falls back to the browser’s native text-to-speech engine.
const SpeakEnglish = async (inputText: string, isWarm: boolean = false) => {
  // 1. Prevention Logic: Stop if already speaking
  if ((window as any).isSpeaking) {
    console.warn('TTS is already in progress. Ignoring request.');
    return;
  }

  try {
    // 2. Set the lock immediately
    (window as any).isSpeaking = true;

    // SpeakNativeEnglish(inputText);
    const response = await fetch(
      `/api/v1/tts?content=${encodeURIComponent(inputText)}&voice=${encodeURIComponent('af_bella')}`,
    );

    if (!response.ok) throw new Error('TTS fetch failed');

    const buffer = await response.arrayBuffer();
    console.log(`Buffer size: ${buffer.byteLength} bytes`);

    playRawPCM(buffer);

    (window as any).isSpeaking = false;
    return;
    const blob = new Blob([buffer], { type: 'audio/wav' });
    alert(`Buffer size: ${buffer.byteLength} bytes`);

    const url = URL.createObjectURL(blob);
    const audio = new Audio(url);
    // const audio = new Audio();
    // audio.src = url;
    // audio.load();

    // 3. Setup Reset Logic via the 'ended' event
    audio.addEventListener('ended', () => {
      (window as any).isSpeaking = false;
      alert('Completed the play');
      URL.revokeObjectURL(url); // Clean up memory
      console.log('TTS Finished: Lock released.');
    });

    // 4. Handle errors during playback
    audio.addEventListener('error', () => {
      alert('error playing audio');
      (window as any).isSpeaking = false;
      URL.revokeObjectURL(url);
    });

    alert('Starting to play');
    await audio.play();
  } catch (err) {
    console.error('TTS Error:', err);
    alert('TTS Error:' + err);
    (window as any).isSpeaking = false; // Release lock so user can try again
    // Fallback if your custom API fails
    SpeakNativeEnglish(inputText);
  }
};

let audioCtx: AudioContext | null = null;

const getAudioCtx = () => {
  if (!audioCtx) {
    // audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)({
    //   sampleRate: 22050,
    // });

    audioCtx = new window.AudioContext({
      sampleRate: 22050,
    });
  }
  return audioCtx;
};
const playRawPCM = async (arrayBuffer: any) => {
  try {
    const audioCtx = getAudioCtx();
    // const audioCtx = new (window.AudioContext || window.webkitAudioContext)({ sampleRate: 22050 });

    console.log('state 01:', audioCtx.state);
    if (audioCtx.state === 'suspended') {
      await audioCtx.resume();
    }
    audioCtx.onstatechange = () => {
      console.log('New State:', audioCtx.state);
      if (audioCtx.state === 'interrupted') {
        audioCtx.resume();
      }
    };
    console.log('state 02:', audioCtx.state);

    // 1. Convert the raw bytes into Float32 (which Web Audio needs)
    const int16Array = new Int16Array(arrayBuffer);
    const float32Array = new Float32Array(int16Array.length);

    for (let i = 0; i < int16Array.length; i++) {
      // Normalize Int16 (-32768 to 32767) to Float32 (-1.0 to 1.0)
      float32Array[i] = int16Array[i] / 32768;
    }

    // 2. Create an AudioBuffer (1 channel, length, sampleRate)
    // Check your TTS documentation for the exact sample rate (e.g., 22050 or 44100)
    const audioBuffer = audioCtx.createBuffer(1, float32Array.length, 22050);
    // audioBuffer.getChannelData(0).set(float32Array);
    audioBuffer.copyToChannel(float32Array, 0);

    console.log(`Playing buffer: ${audioBuffer.duration}s long`);

    // 3. Play it
    console.log('Playing');
    const source = audioCtx.createBufferSource();

    source.buffer = audioBuffer;

    source.onended = () => {
      console.log('Playback finished.');
      source.disconnect();
    };

    source.connect(audioCtx.destination);
    // source.start(0);
    source.start(audioCtx.currentTime + 0);
  } catch (err) {
    console.error('playRawPCM error:', err);
  }
};

const SpeakNativeEnglish = (inputText: string) => {
  const synth = window.speechSynthesis;

  // 1. Cancel any current speech (prevents overlapping/queuing)
  synth.cancel();

  const speakText = new SpeechSynthesisUtterance(inputText);

  // 2. Set language explicitly
  speakText.lang = 'en-US';
  speakText.rate = 1.0;
  speakText.pitch = 1.0;

  // 3. Select a specific English voice (Optional but recommended)
  const voices = synth.getVoices();
  // Try to find a high-quality Google or Apple English voice
  const englishVoice =
    voices.find((v) => v.lang.startsWith('en') && v.name.includes('Google')) ||
    voices.find((v) => v.lang.startsWith('en'));

  if (englishVoice) {
    speakText.voice = englishVoice;
  }

  // Event Listeners
  speakText.onend = () => console.log('Finished speaking');
  speakText.onerror = (e) => console.error('Speech Error:', e);

  // 4. Speak
  synth.speak(speakText);
};

const SpeakJapanese = (inputText: string) => {
  if ('speechSynthesis' in window) {
    const uttr = new SpeechSynthesisUtterance();

    uttr.text = inputText;
    uttr.lang = 'ja-JP';
    uttr.rate = 1;
    uttr.pitch = 1;
    uttr.volume = 1;

    window.speechSynthesis.speak(uttr);
  }
};

const RandomInt = (maxInt: number) => {
  return Math.floor(Math.random() * maxInt);
};

const IsIOS = () => {
  // alert("platform: " + navigator.platform);
  if (/iPad|iPhone|iPod/.test(navigator.platform)) {
    return true;
  } else {
    return (
      navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 2 &&
      /MacIntel/.test(navigator.platform)
    );
  }
};

const IsIpadOS = () => {
  return (
    navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 2 &&
    /MacIntel/.test(navigator.platform)
  );
};

const IsChrome = () => {
  const userAgent = navigator.userAgent;
  const vendor = navigator.vendor;
  // alert("user Agent: " + userAgent);
  // alert("vendor: " + vendor);
  return (
    /Chrome/.test(userAgent) &&
    /Google Inc/.test(vendor) &&
    !/Edg|OPR|Brave/.test(userAgent)
  );
};

const HasTouchScreen = () => {
  let hasTouchScreen = false;
  if ('maxTouchPoints' in navigator) {
    hasTouchScreen = navigator['maxTouchPoints'] > 0;
  } else if ('msMaxTouchPoints' in navigator) {
    hasTouchScreen = navigator['msMaxTouchPoints'] > 0;
  } else {
    const mQ = matchMedia?.('(pointer:coarse)');
    if (mQ?.media === '(pointer:coarse)') {
      hasTouchScreen = !!mQ.matches;
    } else if ('orientation' in window) {
      hasTouchScreen = true; // deprecated, but good fallback
    } else {
      // Only as a last resort, fall back to user agent sniffing
      const UA = navigator['userAgent'];
      hasTouchScreen =
        /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
        /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
    }
  }
  return hasTouchScreen;
};

/**
 * Calculates the FSRS-style rating based on performance metrics.
 */
type EvaluationType = 'per_character' | 'entire_question';

interface RatingSettings {
  EvaluationType: EvaluationType;
  EasyLimit: number;
  GoodLimit: number;
  HardLimit: number;
}

const CalculateRating = (
  isCorrect: boolean,
  timeTaken: number,
  answerLength: number,
  settings?: RatingSettings,
): string => {
  // Default to 'again' if the answer is wrong or settings are missing
  if (!isCorrect || !settings) {
    return 'again';
  }

  // Determine the metric based on the evaluation type
  const metric =
    settings.EvaluationType === 'per_character'
      ? timeTaken / (answerLength || 1)
      : timeTaken;

  // Assign rating based on thresholds
  if (metric < settings.EasyLimit) return 'easy';
  if (metric < settings.GoodLimit) return 'good';
  if (metric < settings.HardLimit) return 'hard';

  return 'again';
};

const CalculateRatingByCorrectness = (
  questions,
  totalTimeTaken: number,
  ratingSetting?: RatingSettings,
): string => {
  if (!questions || questions.length === 0) return 'again';

  const correctCount = questions.filter(
    (q: { is_correct: number }) => q.is_correct === 0,
  ).length;
  const correctnessRate = (correctCount / questions.length) * 100;

  if (correctnessRate === 100) return 'easy';
  if (correctnessRate >= 80) return 'good';
  if (correctnessRate >= 60) return 'hard';
  return 'again';
};

const UID = function () {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
};

const MakeChoicesRandom = (choices: Iterable<unknown> | null | undefined) => {
  console.log('Stating to make choices random');
  console.log(choices);
  let retChoices = [];
  // Remove duplicates and take first 4 unique choices
  let uniqueChoices = Array.from(new Set(choices)).slice(0, 4);

  let num = uniqueChoices.length;
  for (let idx = 0; idx < num; idx++) {
    retChoices.push(
      uniqueChoices.splice(
        Math.floor(Math.random() * uniqueChoices.length),
        1,
      )[0],
    );
  }
  console.log(retChoices);
  return retChoices;
};

export {
  MakeChoicesRandom,
  UID,
  CalculateRating,
  CalculateRatingByCorrectness,
  SpeakEnglish,
  SpeakJapanese,
  RandomInt,
  // LoadServiceWorker,
  IsIOS,
  IsIpadOS,
  IsChrome,
  HasTouchScreen,
  WarmEnglishWord,
};
